/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminUpdateProxiesOptions, AdminUpdateProxiesResponses } from '../../models/AdminUpdateProxies'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Update the org's proxy configuration.
 * @summary Update Org Proxies
 * {@link /admin/org/:org_id/proxy}
 */
export function adminUpdateProxies<ThrowOnError extends boolean = true>(options: Options<AdminUpdateProxiesOptions, ThrowOnError>): Promise<UnwrappedResult<AdminUpdateProxiesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/{org_id}/proxy', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminUpdateProxiesResponses, ThrowOnError>>
}
